'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility.js');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility3 = require('../../../../packages/common-utilities/src/chart_utility');

var _ramda = require('ramda');

var _number_utility = require('common-utilities/src/number_utility');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _d = require('../../../../src/main/resources/static/vendor/scripts/firevis-1.0.1/dependencies/d3-4.2.6/d3.min');

var d3 = _interopRequireWildcard(_d);

var _tracking_utility = require('common-utilities/src/tracking_utility');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable*/
var PremiumDiscountLineChart = function (_React$Component) {
  _inherits(PremiumDiscountLineChart, _React$Component);

  function PremiumDiscountLineChart(props) {
    _classCallCheck(this, PremiumDiscountLineChart);

    var _this = _possibleConstructorReturn(this, (PremiumDiscountLineChart.__proto__ || Object.getPrototypeOf(PremiumDiscountLineChart)).call(this, props));

    _this.trackChartHover = false;
    return _this;
  }

  _createClass(PremiumDiscountLineChart, [{
    key: 'getYAxisTicks',
    value: function getYAxisTicks() {

      var arr = [];
      var data = this.props.historicalETFClosingPriceList;
      if ((0, _ramda.isNil)(data) || data.length === 0) {
        return arr;
      }

      var sortedData = (0, _ramda.sortBy)((0, _ramda.prop)("premiumDiscountPercentage"))(data);
      var maxTick = sortedData[sortedData.length - 1];
      var minTick = sortedData[0];

      var maxYTick = Math.ceil(maxTick.premiumDiscountPercentage / 0.25) * 0.25;
      var minYTick = Math.floor(minTick.premiumDiscountPercentage / 0.25) * 0.25;
      var steps = (maxYTick - minYTick) / 7;

      for (var i = 0; i < 8; i++) {
        arr.push(minYTick + i * steps);
      }
      return arr;
    }
  }, {
    key: 'createPremiumDiscountLineChart',
    value: function createPremiumDiscountLineChart(printWidth) {
      var data = this.props.historicalETFClosingPriceList.filter(function (item) {
        return !(0, _ramda.isNil)(item.premiumDiscountPercentage);
      });
      var isDesktop = this.props.breakpoint > 3;
      var startDate = data[0].fundShareclassPriceDate;
      var endDate = data[data.length - 1].fundShareclassPriceDate;
      var xAxisTicks = [];
      xAxisTicks = _chart_utility2.default.createXAxisTicksForDynamicRange(startDate, endDate, isDesktop);
      var yAxisTicks = this.getYAxisTicks();
      var lessThanOrEqualToThreeMonths = (0, _chart_utility3.isInputRangeLessThanOrEqualToThreeMonths)(startDate, endDate);
      var dateFormat = "%m/%d/%Y";

      var spec = (0, _ramda.mergeDeepLeft)({
        "keys": ["fundShareclassPriceDate"],
        "container": {
          "rangePaddingRight": 50,
          "marginBottom": 50,
          "marginLeft": 50,
          "marginRight": 20
        },
        "style": {
          "fill": ["#70C4FF"]
        },
        "values": ["premiumDiscountPercentage"],
        "type": "line",
        "axis": {
          "x": {
            "show": true,
            "label": {
              "show": true,
              "text": function text(d) {
                return lessThanOrEqualToThreeMonths ? d3.timeFormat(dateFormat)(d) : _date_formatter2.default.getDateInMonthYearFormatNoOffset(d, 'MMM YY');
              }
            },
            "tick": {
              "padding": 5,
              "values": xAxisTicks
            },
            "domain": [d3.timeParse("%Y-%m-%d")(startDate), d3.timeParse("%Y-%m-%d")(endDate)]
          },
          "y": {
            "domain": [yAxisTicks[0], yAxisTicks[yAxisTicks.length - 1]],
            "label": {
              "show": true,
              "text": function text(d) {
                return _number_utility2.default.formatToPercentWithSuppliedDecimalPointCount(d, 2);
              }
            },
            "show": true,
            "tick": {
              "padding": 5,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            }
          }
        },
        "hoverLine": {
          "tooltip": {
            "text": function text(data) {
              if (!this.trackChartHover) {
                _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
                  "eventAction": "premium discount line chart",
                  "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
                });
                this.trackChartHover = true;
              }
              var text = "<div style= 'text-align:left'>";
              for (var _prop in data) {
                if (_prop === "premiumDiscountPercentage" || _prop === "fundShareclassPriceDate") {
                  var propValue = "";
                  if (_prop === "fundShareclassPriceDate") {
                    propValue = "<div class='caption' style='font-weight:100'>" + _date_formatter2.default.getDateInSlashFormat(data[_prop]) + "</div>";
                  } else if (_prop === "premiumDiscountPercentage") {
                    propValue = "<div class='caption' style='font-weight:400'>" + _number_utility2.default.formatToPercentWithSuppliedDecimalPointCount(data[_prop], 2) + "</div>";
                  }
                  text += propValue;
                }
              }
              text += "</div>";
              return text;
            }
          }
        },
        "postProcessing": function postProcessing(chart) {
          chart.getPlot().selectAll(".tick line").style("stroke", "lightgrey");
        }
      }, _chart_utility3.COMMON_CHART_CONFIG);

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility3.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility3.getChartPrintHeight)();
      }

      return (0, _chart_utility.generateChart)((0, _chart_utility3.generateChartId)("PremiumDiscountLineChart", printWidth && typeof printWidth === "number"), "linechart", data, spec);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.historicalETFClosingPriceList.length === 0) {
        return null;
      }
      var premiumDiscountLineChart = this.createPremiumDiscountLineChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(premiumDiscountLineChart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createPremiumDiscountLineChart(800))
        )
      );
    }
  }]);

  return PremiumDiscountLineChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = PremiumDiscountLineChart;